import {
    SET_FAV_STATE,
    SET_FAV_GROUP,
    SET_FAV_PAGE,
    SET_FAV_DATA,
    DELETE_FAV_ITEM,
    SET_FAV_ITEM_DATA,
    RESET_FAV_DATA,
    SET_ADD_TO_CART,
    ADD_FAV_GROUP,
    CLEAR_REQ_PARAMS,
    CLEAR_STATE, SET_ALL_ADD_TO_CART

} from '../costants/ActionTypes'

const initialState = {
  status: "NOT_LOADED",
  page: 1,
  page_size: 1,
  group: '',
  count: 0,
  next: null,
  previous: null,
  extra_rows: [],
  items: [],
  groups: []
}


const favorite = (state = initialState, action) => {

    switch (action.type) {
        case CLEAR_REQ_PARAMS:
            return Object.assign({}, state, {
                status: "NOT_LOADED",
                page: 1,
                group: "",
          })
        case CLEAR_STATE:
            return Object.assign({}, state, initialState)

        case SET_FAV_STATE:
          return Object.assign({}, state, {
              status: action.status
          })

        case SET_FAV_PAGE:
          return Object.assign({}, state, {
              page: action.page,
              status: "NOT_LOADED"
          })

        case SET_FAV_GROUP:
          return Object.assign({}, state, {
              group: action.group,
              status: "NOT_LOADED"
          })

        case ADD_FAV_GROUP:
            return Object.assign({}, state, {
            groups: [...state.groups].concat([action.group])
          })

        case DELETE_FAV_ITEM:

          const new_items = state.items.filter((element) => {return element.id !== action.item_id})

          return Object.assign({}, state, {
            items: [...new_items]
          })

        case RESET_FAV_DATA:
          return Object.assign({}, state, action.data)

        case SET_FAV_DATA:

          let new_state = Object.assign({}, state, {
              page_size: action.data.page_size,
              count: action.data.count,
              next: action.data.next,
              previous: action.data.previous
          })

          if (action.data.results){
              new_state.items = [...action.data.results]
          }
          if (action.data.groups){
              new_state.groups = [...action.data.groups]
          }
          if (action.data.group){
              new_state.group = action.data.group
          }
          if (action.data.extra_rows){
              new_state.extra_rows = [...action.data.extra_rows]
          }

          return new_state

        case SET_FAV_ITEM_DATA:

          const copy_items = state.items.map((element, index) => {
              if (element.id === action.data.id) {
                  return action.data
              }
              return element
          });

          return Object.assign({}, state, {
            items: [...copy_items]
          })

        case SET_ADD_TO_CART:
          const cart_items = state.items.map((element, index) => {
              if ((element.sku === action.sku) && (element.group === action.group)) {
                  return Object.assign({}, element, {in_cart:true})
              }
              return element
          });

          return Object.assign({}, state, {
            items: [...cart_items]
          })

        case SET_ALL_ADD_TO_CART:
            const all_items = state.items.map((element, index) => {
              if (element.checked) {
                  return Object.assign({}, element, {in_cart:true})
              }
              return element
          });

          return Object.assign({}, state, {
            items: [...all_items]
          })

        default:
        return state

  }
}

export default favorite